import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts } from "@ofqual/portal-core/core/types";



export class CountryService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/countries?portalOnly=true`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.description, active: item.active }));
  }
  public async get(id: string, opts: Opts): Promise<Model> {
    const url = `${this.apiRoot}/countries/${id}`;
    return await super.getRequest<Model>(url, opts);
  }
}


export class RefDataService extends BaseRemoteService {
  private resource: string;

  constructor(baseUrl: string, resource: string) {
    super(baseUrl);
    this.resource = resource;
  }
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/${this.resource}`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data
      .filter((x) => x.active)
      .map((x) => ({ id: x.id, label: x.description }));
  }
  public async get(id: string, opts: Opts): Promise<Model> {
    const url = `${this.apiRoot}/${this.resource}/${id}`;
    const item = await super.getRequest<Model>(url, opts);
    return {
      ...item,
      label: item.value,
    };
  }
}

export const refDataEndpoints = {
  countryOptions: "countries?portalOnly=true",

};
